import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { TeamProvider } from './context/TeamContext';
import { BookmarkProvider } from './context/BookmarkContext';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ThemeProvider>
      <AuthProvider>
        <BookmarkProvider>
          <TeamProvider>
            <App />
          </TeamProvider>
        </BookmarkProvider>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);